module.exports = __webpack_public_path__ + "media/assets/images/logos/ncino_logo_no_text_color-ee03638b542656be077e84e55935ece0.png";